import React, { Suspense, lazy, FC } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorBoundary from "./ErrorBoundary";
import Grid from "@mui/material/Grid";

// Assuming both VideoCall and Chat components are default exports and are React functional components
const VideoCall = lazy(() => import("./Pages/VideoCall"));
const Chat = lazy(() => import("./Pages/Chat"));
// Phase 5.6H — email-link external-customer video-call lobby. Reads the
// opaque join-link token from the URL path (`/calls/:token`), hits
// Lane 5.6G's public Lookup + Join endpoints, then mounts the same
// CallComposite the /video-call route uses.
const CallLobbyPage = lazy(() => import("./Pages/CallLobby/CallLobbyPage"));
const HomePage = lazy(() => import("./Pages/Home/HomePage"));

const App: FC = () => {
  return (
    <Suspense
      fallback={
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: "100vh" }}
        >
          <Grid item xs={3}>
            <CircularProgress style={{ color: "#F8692F" }} />
          </Grid>
        </Grid>
      }
    >
      <Router>
        <ErrorBoundary>
          <Routes>
            <Route path="/video-call" element={<VideoCall />} />
            <Route path="/chat" element={<Chat />} />
            {/* Phase 5.6H — opaque-token public video-call lobby. */}
            <Route path="/calls/:token" element={<CallLobbyPage />} />
            <Route path="/" element={<HomePage />} />
          </Routes>
        </ErrorBoundary>
      </Router>
    </Suspense>
  );
};

export default App;
